import { callApi } from './ApiClient';

const getProxyLoginUser = (id, token, dispatch) => {
  return callApi("GET", `/admin/proxy_login/users/${id}/${token}`, null, dispatch);
};

export const ProxyLoginUserApi = {
  getProxyLoginUser
};



// WEBPACK FOOTER //
// ./src/redux/api/ProxyLoginUserApi.js